export default __webpack_public_path__ + "c93697022518ff79044e4cb870beaf07.svg";